import { withInstall, withNoopInstall } from '@zoryn/utils'
import Tour from './src/tour.vue'
import TourStep from './src/step.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTour: SFCWithInstall<typeof Tour> & {
  TourStep: typeof TourStep
} = withInstall(Tour, {
  TourStep,
})
export const ZTourStep: SFCWithInstall<typeof TourStep> =
  withNoopInstall(TourStep)
export default ZTour

export * from './src/tour'
export * from './src/step'
export * from './src/content'
export type { TourMask, TourGap, TourBtnProps } from './src/types'
